import {
  EventTypeBackend,
  EventUnionWithPermissions,
  GrantEvent,
} from '../../../../types/events.types';

export const mergeGrantSignatoryAssignmentsForDisplay = (
  formAssignments: Record<string, { fullName?: string; id: string } | null | undefined> | undefined,
  event: EventUnionWithPermissions | null,
): Record<string, { fullName?: string; id: string }> => {
  const fromForm = (formAssignments ?? {}) as Record<string, { fullName?: string; id: string }>;
  if (event?.type !== EventTypeBackend.GRANT) {
    return fromForm;
  }
  const raw = (event as GrantEvent).signatoryAssignments;
  if (!raw || Object.keys(raw).length === 0) {
    return fromForm;
  }
  const fromGrant: Record<string, { fullName?: string; id: string }> = {};
  for (const [k, v] of Object.entries(raw)) {
    if (v?.id) {
      fromGrant[k] = { fullName: v.fullName, id: v.id };
    }
  }
  const merged: Record<string, { fullName?: string; id: string }> = { ...fromGrant };
  for (const [k, v] of Object.entries(fromForm)) {
    if (!v?.id) continue;
    merged[k] = {
      id: v.id,
      fullName: v.fullName || fromGrant[k]?.fullName,
    };
  }
  return merged;
};

export const resolveGrantSignatoryDisplayName = (
  signatoryTypeId: string,
  assignments: Record<string, { fullName?: string; id: string }>,
  grantItems: Array<{ stakeholder: { fullName?: string; id: string } }>,
): string => {
  const a = assignments[signatoryTypeId];
  if (!a?.id) {
    return '—';
  }
  if (a.fullName) {
    return a.fullName;
  }
  const fromGrantItem = grantItems.find((gi) => gi.stakeholder.id === a.id)?.stakeholder.fullName;
  return fromGrantItem ?? '—';
};
